import http from "./Endpoint";


class XmpieService {

  /**
   * Return adors - informations to customize a product
   * @param {*} productId - product to be customize
   * @param {*} userId - used to prefill values
   * @returns 
   */
  query(productId, userId) {
    const article = {
      "filter": {
        product_id: productId,
        user_id: userId
      }
    }
    return http().post("/xmpie/query", article);
  }

  /**
   * Generate proof after customization
   * @param {*} data - ador values
   * @returns 
   */
  proof(data) {
    const loginForm = new FormData();
    for (var key in data) {
      loginForm.append(key, data.key);
    }
    return http().post("/xmpie/proof", loginForm);
  }

  /**
   * Get list of resources like validations
   */
  list() {
    return http().post("/xmpie/list");
  }

  /**
   * Update adors
   */
  update(customerId, productId, article) {
    const data = {
      customer_id: customerId,
      product_id: productId,
      adors: article
    }
    return http().post("/xmpie/update", data);
  }


}

export default new XmpieService();